const userLevels = [
  { value: "0", label: "PwC Administrator", description: "PwC Internal Admin User" },
  { value: "1", label: "PwC User", description: " PwC Internal Display User" },
  { value: "2", label: "Client Admin", description: "Client all display user + ability to add new Client Users" },
  { value: "3", label: "Technical", description: "Client Display User with technical details" },
  { value: "4", label: "Business", description: "Client Display User without technical details" }
];

export { userLevels };